import { TFormalOffer } from './formalOffers.types';

/**
 * Checks if a formal offer matches the loan_offer_id on an account.
 *
 * account.loan_offer_id` is populated with the most recently drawn down formal offer's `offer_id`.
 *
 * @param formalOffers An array of formal offers.
 * @param loanOfferId A uuid
 * @returns A single formal offer if there is a match, `undefined` otherwise.
 */
export const getFormalOfferByLoanOfferId = (
    formalOffers: TFormalOffer[],
    loanOfferId: string
) => {
    return formalOffers.filter((offer) => offer.offer_id === loanOfferId)[0];
};
